<div class="row">
  <div class="col-md-7 p-0">
    <div class="card  p-3 category-container">
      <h4>Ticket Categories</h4>
      <div #orignRef class="d-flex flex-column align-items-end mb-3">
        <button class="btn btn-sm btn-primary" (click)="addCategory(orignRef)"><svg xmlns="http://www.w3.org/2000/svg"
            width="16" height="16" fill="#fff" class="bi bi-plus svgPlus" viewBox="0 0 16 16">
            <path
              d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z" />
          </svg>Add New Category</button>
      </div>
      <table class="table table-striped  table-sm row-border hover" datatable [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger">
        <thead>
          <tr>
            <th>S/N</th>
            <th>Category ID</th>
            <th>Category Text</th>
            <th>Help Text</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let category of categories;let i = index">
            <td>{{i+1}}</td>
            <td>{{category.categoryID}}</td>
            <td>{{category.categoryText}}</td>
            <td>
              <div [innerHTML]="category.helpText" class="p-3 response-box"></div>
            </td>
            <td>
              <mat-icon class="icon-sm cursorP" svgIcon="mat:edit" data-toggle="tooltip" data-placement="top"
                title="Edit" (click)="editCategory(orignRef,category)"></mat-icon>

              <mat-icon class="icon-sm cursorP" svgIcon="mat:delete_outline" data-toggle="tooltip" data-placement="top"
                title="Delete" (click)="deleteCategory(category)"></mat-icon>
            </td>

          </tr>
        </tbody>
      </table>

    </div>
  </div>

  <div class="col-md-5 p-0">
    <app-complaint-category-mapping ></app-complaint-category-mapping>
  </div>
</div>